import { render } from "./Atender.vue?vue&type=template&id=52f0cd57&scoped=true"
import script from "./Atender.vue?vue&type=script&lang=js"
export * from "./Atender.vue?vue&type=script&lang=js"

import "./Atender.vue?vue&type=style&index=0&id=52f0cd57&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f0cd57"]])

export default __exports__